export const C = {
  navy: "#0F2557",
  navyDark: "#081540",
  blue: "#1A3A8F",
  blueLight: "#2451B3",
  gold: "#B8860B",
  goldLight: "#D4A017",
  goldBg: "#FFF8E7",
  white: "#FFFFFF",
  bg: "#F4F6FB",
  bgAlt: "#EEF1F9",
  text: "#1A1A2E",
  textMid: "#3D4B6E",
  textMuted: "#6B7A9B",
  border: "#D6DDEF",
  borderLight: "#E8ECF6",
  accent: "#E8F0FE",
  accentDeep: "#C2D3FB",
  red: "#C0392B",
  green: "#1A7A4A",
  teal: "#0E7490",
  purple: "#5B21B6",
};
